export default __webpack_public_path__ + "static/burr-321268db5866cf2a030488054399599a.png";